import { type InputHTMLAttributes, type ReactNode, forwardRef } from 'react'

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode
  error?: boolean
}

/** Radio custom, stesso principio del Checkbox: input nativo invisibile (appearance-none) per
 * accessibilità/register(), pallino disegnato da noi sopra. */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, error, className = '', id, ...rest },
  ref
) {
  return (
    <label htmlFor={id} className="flex w-fit cursor-pointer items-center gap-2 text-sm text-body select-none">
      <span className="relative inline-flex h-4 w-4 shrink-0 items-center justify-center">
        <input
          type="radio"
          id={id}
          ref={ref}
          className={`da-radio peer h-4 w-4 shrink-0 appearance-none rounded-full border bg-canvas checked:border-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500/40 ${error ? 'border-danger-500' : 'border-border-strong'} ${className}`}
          {...rest}
        />
        <span className="pointer-events-none absolute h-2 w-2 scale-0 rounded-full bg-primary-600 peer-checked:scale-100" />
      </span>
      {label}
    </label>
  )
})
